import { Component } from '@angular/core';

import { PeopleListComponent } from '../people-list/people-list.component';
import { PeopleTabConfig } from '../people-list/people-tab-config';

@Component({
    selector: 'app-people-employees',
    standalone: true,
    imports: [PeopleListComponent],
    template: `<app-people-list [config]="config"></app-people-list>`,
})
export class PeopleEmployeesComponent {
    config: PeopleTabConfig = {
        title: 'Employees',
        roleAttributes: ['employee'],
        showCreate: true,
        showInvite: true,
        showNewOpportunity: false,
        showCreateCrew: false,
        showJobs: false,
        showRoleFilter: true,
    };
}